import type { FormHTMLAttributes, HTMLAttributes } from 'react';
import type { Space } from '../tokens/tokens';
import styles from './Stack.module.css';

export interface StackProps
  extends HTMLAttributes<HTMLElement>,
    Pick<FormHTMLAttributes<HTMLFormElement>, 'noValidate' | 'action' | 'method'> {
  direction?: 'column' | 'row';
  gap?: Space;
  align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline';
  justify?: 'start' | 'center' | 'end' | 'between';
  wrap?: boolean;
  as?: 'div' | 'ul' | 'ol' | 'form' | 'fieldset';
}

/** Layout primitive: children in a row or column with token based gaps. */
export function Stack({
  direction = 'column',
  gap = 4,
  align,
  justify,
  wrap = false,
  as: Element = 'div',
  className,
  style,
  ...rest
}: StackProps) {
  const classes = [
    styles.stack,
    styles[direction],
    align && styles[`align-${align}`],
    justify && styles[`justify-${justify}`],
    wrap && styles.wrap,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <Element
      className={classes}
      style={{ gap: `var(--space-${gap})`, ...style }}
      {...(rest as object)}
    />
  );
}
